export default __webpack_public_path__ + "static/media/NeiomiShmoel.238fba0e.jpg";